<script setup>
import EditInput from "@/components/global/inputs/EditInput.vue";
import {computed, ref} from "vue";

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator(value) {
      return ['customers', 'subscriptions', 'accounts'].includes(value);
    },
  },
  stripeId: {
    type: String,
    require: true,
    default: null,
  },
  parentAccountId: {
    type: [String, null],
    required: false,
    default: null,
  },
  isMerchantCustomer: {
    type: Boolean,
    required: false,
    default: false,
  },
  organisationId: {
    type: Number,
    required: true,
  },
});

const baseStripeUrl = 'https://dashboard.stripe.com';
const localStripeId = ref(props.stripeId)

const merchantPrefix = `${props.isMerchantCustomer ? `connect/accounts/${props.parentAccountId}/` : ''}`
const stripeUrl = computed(() => `${baseStripeUrl}/${merchantPrefix}${props.type}/${localStripeId.value}`)
const updateUrl = `/admin/crm/organisations/${props.organisationId}/update-stripe-${props.type}-id`;
const disabled = computed(() => props.type === 'accounts' && props.isMerchantCustomer);

const success = (event) => localStripeId.value = event;
</script>

<template>
  <EditInput
    :url="updateUrl"
    :current-value="localStripeId"
    :disabled="disabled"
    @success="success"
  >
    <a
      :href="stripeUrl"
      target="_blank"
    >
      {{ localStripeId }}
    </a>
  </EditInput>
</template>
